import DetailLayout from './DetailLayout';
import GeneralDetailLayout from '../../../components/GeneralDetailLayout';
import CompanySectionContainer from '../../../components/CompanySectionContainer';
import { Box, Button, Stack } from '@mui/material';
import { USER_QUERY_KEY } from 'src/constants/query';
import { userIdSelector, userMfaStatusSelector } from 'src/selectors/user';
import { pagesText } from 'src/constants/pagesText';
import { useNavigate } from 'react-router-dom';
import { PORTAL_ROUTE } from 'src/constants/routes';
import useDisableMfa from 'src/queries/user/useDisableMfa';
import { useSnackbar } from 'notistack';
import useFetchUser from 'src/queries/user/useFetchUser';
import { useQuery } from 'react-query';

const MultiFactor = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const disableMfa = useDisableMfa();

  const { data: user } = useQuery(USER_QUERY_KEY, useFetchUser());
  const userId = userIdSelector(user);
  const mfaStatus = userMfaStatusSelector(user);

  const handleMfaDisable = async () => {
    await disableMfa.mutateAsync(userId, {
      onSuccess: () => {
        enqueueSnackbar(pagesText.mfaDetails.disabledSuccess, {
          variant: 'success',
        });
      },
    });
  };

  return (
    <CompanySectionContainer>
      <GeneralDetailLayout title={pagesText.mfaDetails.title}>
        <DetailLayout>
          {/* stack for padding to fit page */}
          <Stack direction="row" alignItems="baseline" gap={0.75}>
            <Button
              variant="outlined"
              fullWidth
              color={mfaStatus ? 'error' : 'primary'}
              onClick={() => {
                if (mfaStatus) {
                  handleMfaDisable();
                } else {
                  navigate(`${PORTAL_ROUTE}/accounts/mfa-setup`);
                }
              }}>
              {mfaStatus ? pagesText.mfaLabels.disable : pagesText.mfaLabels.enable}
            </Button>
            <Box width={70} height={40} />
            {/* padding box to fit the page */}
          </Stack>
        </DetailLayout>
      </GeneralDetailLayout>
    </CompanySectionContainer>
  );
};

export default MultiFactor;
